"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractRawQueryParam = extractRawQueryParam;
exports.decodeReputationMessageParam = decodeReputationMessageParam;
exports.parseReputationVoteLink = parseReputationVoteLink;
const utils_1 = require("../utils");
function extractQueryString(rawUrl) {
    const url = rawUrl.trim();
    if (!url)
        return '';
    if (url.startsWith('http')) {
        try {
            return new URL(url).search.slice(1);
        }
        catch {
            return '';
        }
    }
    const withoutPath = url.replace(/^forum\/index\.php\?/i, '');
    return withoutPath.includes('?') ? withoutPath.split('?').pop() : withoutPath;
}
/** Значение query-параметра до UTF-8 декодирования `URLSearchParams` (нужно для Win-1251). */
function extractRawQueryParam(query, name) {
    const pattern = new RegExp(`(?:^|[&;])${name}=([^&]*)`, 'i');
    const match = query.match(pattern);
    return match ? match[1] : null;
}
/** Побайтовый %XX decode (без UTF-8 валидации `decodeURIComponent`). */
function decodePercentEncodedBytes(raw) {
    const bytes = [];
    for (let i = 0; i < raw.length; i++) {
        const ch = raw[i];
        if (ch === '%' && i + 2 < raw.length) {
            const hex = raw.slice(i + 1, i + 3);
            if (/^[0-9A-Fa-f]{2}$/.test(hex)) {
                bytes.push(parseInt(hex, 16));
                i += 2;
                continue;
            }
        }
        if (ch === '+') {
            bytes.push(0x20);
            continue;
        }
        bytes.push(ch.charCodeAt(0) & 0xff);
    }
    return new Uint8Array(bytes);
}
/**
 * Декодирует `message=` из ссылок форума: percent-encoding байтов Win-1251.
 * Пример: `%D1%EF%E0%F1%E8%E1%EE` → «Спасибо».
 */
function decodeReputationMessageParam(raw) {
    if (!raw)
        return '';
    try {
        return (0, utils_1.decodeFromWin1251)(decodePercentEncodedBytes(raw));
    }
    catch {
        return raw;
    }
}
/** `act=rep` + `view=win_add|win_minus` или `type=win_add|win_minus` (как Android o1.java). */
function parseReputationVoteLink(params, rawUrl) {
    if ((params.get('act') || '').toLowerCase() !== 'rep')
        return null;
    const viewOrType = (params.get('view') || params.get('type') || '').toLowerCase();
    let direction = null;
    if (viewOrType === 'win_add')
        direction = 1;
    else if (viewOrType === 'win_minus')
        direction = 0;
    else
        return null;
    const userId = parseInt(params.get('mid') || '', 10);
    if (!Number.isFinite(userId) || userId <= 0)
        return null;
    const postId = parseInt(params.get('p') || '0', 10);
    const query = rawUrl ? extractQueryString(rawUrl) : '';
    const messageRaw = query ? extractRawQueryParam(query, 'message') : null;
    const prefilledReason = messageRaw ? decodeReputationMessageParam(messageRaw) : '';
    return {
        userId,
        postId: Number.isFinite(postId) && postId > 0 ? postId : 0,
        direction,
        prefilledReason,
    };
}
